<template>
  <ListingsCheckboxFilter
    v-model="proxyModelValue"
    :analytics-event="EAnalyticsEvent.DASHBOARD_FILTERS_HIDE_CONTACTS_CHANGED"
    :disabled="disabled"
    label="Hide contacts that have moved home?"
    explanation="These are where you have the owner in your CRM but they have since sold the home"
  />
</template>

<script lang="ts" setup>
  // Types
  import type { WritableComputedRef } from 'vue';
  import { EAnalyticsEvent } from '~/misc/services/analytics/types';

  // Components
  import ListingsCheckboxFilter from '~/misc/listings/filters/checkbox/ListingsCheckboxFilter.vue';

  const emit = defineEmits<{
    (e: 'update:modelValue', value: boolean): void;
  }>();

  const props = defineProps({
    modelValue: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  });

  const proxyModelValue: WritableComputedRef<boolean> = computed({
    get(): boolean {
      return props.modelValue;
    },
    set(value: boolean): void {
      emit('update:modelValue', value);
    },
  });
</script>
